import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { twMerge } from 'tailwind-merge';
export default function TextArea(props) {
  const {
    className,
    error,
    fullWidth,
    ...rest
  } = props;
  const focusClasses = 'focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-20 transition-shadow';
  const errorFocusClasses = 'focus:border-red-500 focus:ring focus:ring-red-500 focus:ring-opacity-20 transition-shadow';
  const disabledClasses = 'disabled:bg-gray-200 disabled:border-gray-200';
  const classes = twMerge(className, 'form-textarea', 'border-gray-400 rounded', error ? errorFocusClasses : focusClasses, disabledClasses, fullWidth && 'block w-full');
  return /*#__PURE__*/React.createElement("textarea", _extends({
    className: classes
  }, rest));
}